import React, { useState } from "react";
import { Link } from "react-router-dom";
import image from "../../assets/images/exclusive-features.png";

function ExclusiveFeatures({ data }) {
  const [activeFeature, setActiveFeature] = useState(0);
  
  return (
    <section className="section">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h2 className="section-title">Exclusive Features</h2>
            <p className="section-subtitle">
              Discover the unique capabilities and features that set our solutions apart
            </p>
          </div>
        </div>
        
        <div className="exclusive-features-container">
          {/* Desktop Tabs */}
          <div className="exclusive-features-tabs">
            <div className="tabs-container">
              {data?.map((item, index) => (
                <button
                  key={index}
                  className={`tab-button ${activeFeature === index ? 'active' : ''}`}
                  onClick={() => setActiveFeature(index)}
                >
                  {item.title}
                </button>
              ))}
            </div>
          </div>
          
          {/* Content Area */}
          <div className="exclusive-features-content">
            <p className="exclusive-features-description">
              {data[activeFeature]?.description}
            </p>
          </div>
          
          {/* Mobile Cards */}
          <div className="exclusive-features-mobile-cards">
            <div className="mobile-cards-left">
              {data?.slice(0, 3).map((item, index) => (
                <div className="mobile-card" key={index}>
                  <div className="service-card">
                    <div className="service-content">
                      <h4 className="service-title">
                        {item.title}
                      </h4>
                      <p className="service-description">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="mobile-cards-right">
              <div className="mobile-image">
                <img src={image} alt="" className="img-fluid" />
              </div>
              {data?.slice(3, data.length).map((item, index) => (
                <div className="mobile-card" key={index}>
                  <div className="service-card">
                    <div className="service-content">
                      <h4 className="service-title">
                        {item.title}
                      </h4>
                      <p className="service-description">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExclusiveFeatures;
